import { useMutation, useQueryClient } from 'react-query';
import { shutdownsQuery } from '../../../../shared/api/queries';
import request from '../../../../../../helpers/request';
import { useGenerateAlisaAudio } from '../../generateAlisaAudio';
import { useDispatch } from 'react-redux';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';

const { useShutdownsQueryKey } = shutdownsQuery;

const changeAlisaText = async ({ shutdownId, data }) => {
  const res = await request.put(
    `/Alert/alisa_text/${shutdownId}`,
    data,
    'Не удалось сохранить текст автоответа',
    'Error'
  );

  return res;
};

export const useShutdownAlisaTextChange = (options = {}) => {
  const dispatch = useDispatch();
  const { generateAudio } = useGenerateAlisaAudio();

  const changeMutation = useMutation(changeAlisaText, {
    ...options,
    onSuccess: async (res, { shutdownId, data }) => {
      if (res !== 'Error') {
        if (data.value) {
          await generateAudio({
            shutdownId,
            text: data.value,
          });
        }

        dispatch(fetchShutdownsThunk());
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
